import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { titleProps } from '../common/helpers/title-props';
import { ContactDataDisclaimer } from '../common/components/contact-data-disclaimer';

export function LiberisCompanyDataTitle() {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography {...titleProps} sx={{ marginBottom: '8px' }}>
        {t('welcomePage.loanApplicationPossible.liberis.companyData.title')}
      </Typography>
      <Typography fontSize={20} lineHeight={'24px'}>
        {t('welcomePage.loanApplicationPossible.liberis.companyData.subtitle')}
      </Typography>
      <ContactDataDisclaimer />
    </Box>
  );
}
